module.exports = __webpack_public_path__ + "img/ic_h5_vip1.bf835b9f.png";